import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/Home'
import Login from '../pages/user/Login.vue'
// import NewLogin from '../pages/user/new_login.vue'
import Team from '../pages/tool/Team.vue'
import Snippets from '../pages/tool/Snippets.vue'
import Snippets2 from '../pages/tool/Snippets2.vue'
import WT3T from '../pages/tool/WT3T.vue'
import Claim from '../pages/tool/Claim.vue'
import Invoice2 from '../pages/tool/Invoice2.vue'
// import Workday from '../pages/tool/Workday.vue'
import Admin from '../pages/tool/Admin.vue'
import Hardware from '../pages/tool/Hardware.vue'
import TGIF from '../pages/tool/TGIF.vue'
import Structure from '../pages/tool/Structure.vue'
import ServerStatus from '../pages/tool/ServerStatus.vue'
import School from '../pages/tool/School.vue'
import AdsStatus from '../pages/tool/AdsStatus.vue'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


const routes = [
  //  首页
  {
    path: '/',
    component: Home,
    meta: {
      title: 'Corp Tools - Diggo'
    },
  },
  //  登录
  {
    path: '/login',
    component: Login,
    meta: {
      title: 'Login - Diggo'
    }
  },
  // {
  //   path: '/new-login',
  //   component: NewLogin,
  //   meta: {
  //     title: 'Login - Diggo'
  //   }
  // },
  //  员工信息
  {
    path: '/team',
    component: Team,
    meta: {
      title: 'Team - Diggo'
    },
  },
  {
    path: '/team/:name',
    component: Team,
    meta: {
      title: 'Team - Diggo'
    },
  },
  //  工作报告
  {
    path: '/snippets',
    component: Snippets,
    meta: {
      title: 'Snippets - Diggo'
    }
  },
  {
    path: '/snippets/:name',
    component: Snippets,
    meta: {
      title: 'Snippets - Diggo'
    }
  },
  //  工作报告 - 改版
  {
    path: '/snippets2',
    component: Snippets2,
    meta: {
      title: 'Snippets - Diggo'
    }
  },
  {
    path: '/snippets2/:name',
    component: Snippets2,
    meta: {
      title: 'Snippets2 - Diggo'
    }
  },
  // 周报
  {
    path: '/wt3t',
    component: WT3T,
    meta: {
      title: 'WT3T - Diggo'
    }
  },
  // {
  //   path: '/wt3t/:name',
  //   component: WT3T,
  //   meta: {
  //     title: 'WT3T - Diggo'
  //   }
  // },
  //  发票报销
  {
    path: '/claim',
    component: Claim,
    meta: {
      title: 'Claim - Diggo'
    }
  },
  {
    path: '/claim/:category',
    component: Claim,
    meta: {
      title: 'Claim - Diggo'
    }
  },
  {
    path: '/invoice2',
    component: Invoice2
  },
  //  请假
  // {
  //   path: '/workday',
  //   component: Workday,
  //   meta: {
  //     title: 'Workday - Diggo'
  //   }
  // },
  // {
  //   path: '/workday/:category',
  //   component: Workday,
  //   meta: {
  //     title: 'Workday - Diggo'
  //   }
  // },
  //  员工管理
  {
    path: '/admin',
    component: Admin,
    meta: {
      title: 'Admin - Diggo'
    }
  },
  {
    path: '/admin/:category',
    component: Admin,
    meta: {
      title: 'Admin - Diggo'
    }
  },
  //  设备
  {
    path: '/hardware',
    component: Hardware,
    meta: {
      title: 'Hardware - Diggo'
    }
  },
  //  TGIF
  {
    path: '/dory',
    component: TGIF,
    meta: {
      title: 'Dory - Diggo'
    }
  },
  {
    path: '/dory/:category',
    component: TGIF,
    meta: {
      title: 'Dory - Diggo'
    }
  },
  // 团队结构
  {
    path: '/structure',
    component: Structure,
    meta: {
      title:'Team - Diggo'
    }
  },
   // 服务器状态
   {
    path: '/server',
    component: ServerStatus,
    meta: {
      title:'Server - Diggo'
    }
  },
   // 服务器状态
   {
    path: '/ads',
    component: AdsStatus,
    meta: {
      title:'Ads - Diggo'
    }
  },
  // 学校信息
  {
    path: '/school',
    component: School,
    meta: {
      title:'School - Diggo'
    }
  }
]

var router = new VueRouter({
  mode:'history',
  routes
})

export default router
